/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum ReservedBloodProductsStartAliases {
  ACCORDION = 'accordion',
  ACCORDION_PANEL = 'accordion-panel',
  ACCORDION_PLUS_TITLE_PANEL = 'accordion-plus-title-panel',
  ACCORDION_PLUS_TITLE_TEXT = 'accordion-plus-title-text',
  ACCORDION_TITLE_PANEL = 'accordion-title-panel',
  ACCORDION_TITLE_TEXT = 'accordion-title-text',
  BARCODE_BAG = 'barcode-bag',
  BARCODE_PANEL_BAG = 'barcode-panel-bag',
  BLOOD_TYPING_FIELD = 'blood-typing-field',
  BLOOD_TYPING_TEXT = 'blood-typing-text',
  BUTTON = 'button',
  BUTTON_PANEL_PADDING = 'button-panel-padding',
  CARD = 'card',
  CARD_DECK = 'card-deck',
  CARD_PANEL = 'card-panel',
  CARDS_ACCORDION = 'cards-accordion',
  CARDS_ACCORDION_PANEL = 'cards-accordion-panel',
  CONTENT_PANEL = 'content-panel',
  DATE_TIME_FIELD = 'date-time-field',
  DATE_TIME_TEXT = 'date-time-text',
  DEVICE_AUTOCOMPLETE = 'device-autocomplete',
  DEVICE_FETCH = 'device-fetch',
  DEVICE_FIELD = 'device-field',
  DEVICE_MAPPER = 'device-mapper',
  DEVICE_TEXT = 'device-text',
  FORM = 'form',
  GLOBAL_ACTIONS = 'global-actions',
  INFUSION_FORM_AUTOCOMPLETE = 'infusion-form-autocomplete',
  INFUSION_FORM_FETCH = 'infusion-form-fetch',
  INFUSION_FORM_FIELD = 'infusion-form-field',
  INFUSION_FORM_MAPPER = 'infusion-form-mapper',
  INFUSION_FORM_TEXT = 'infusion-form-text',
  LEGENDS_START = 'legends-start',
  NAME_DATE_PANEL = 'name-date-panel',
  NAME_FIELD = 'name-field',
  NAME_TEXT = 'name-text',
  NEW_DATE_FIELD = 'new-date-field',
  NEW_DATE_INPUT = 'new-date-input',
  NOTES_FIELD = 'notes-field',
  NOTES_TEXT_AREA = 'notes-text-area',
  RESERVED_BLOOD_PRODUCT_LAYOUT = 'reserved-blood-product-layout',
  UNITY_AUTOCOMPLETE = 'unity-autocomplete',
  UNITY_FETCH = 'unity-fetch',
  UNITY_FIELD = 'unity-field',
  UNITY_MAPPER = 'unity-mapper',
  UNITY_TEXT = 'unity-text',
  VOLUME_STEP_FIELD = 'volume-step-field',
  VOLUME_STEP_INPUT = 'volume-step-input',
}
export { ReservedBloodProductsStartAliases };
